import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-black bg-opacity-25" }, null, -1)
const _hoisted_2 = { class: "fixed inset-0 overflow-y-auto" }
const _hoisted_3 = { class: "flex min-h-full items-center justify-center p-4 text-center" }
const _hoisted_4 = {
  key: 0,
  class: "text-center mb-4"
}
const _hoisted_5 = {
  key: 1,
  class: "text-center mb-4"
}
const _hoisted_6 = { class: "mt-3 text-darkgray-800 leading-7" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "mt-6" }

import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogPanel,
  DialogTitle,
} from '@headlessui/vue'
import ButtonComponent from '@/components/ButtonComponent.vue';
import { CheckCircleIcon } from '@heroicons/vue/24/outline'


export default /*#__PURE__*/_defineComponent({
  __name: 'GeneralModal',
  props: {
    show: {
        type: Boolean
    },
    loader: {
        type: Boolean
    },
    title: {
        type: String,
    },
    content: {
        type: String,
    },
    actionText: {
        type: String,
    },
    cancelText: {
        type: String,
    },
    width: {
        type: String,
    },
    checkIcon: {
        type: Boolean,
        default: false
    },
    withIcon: {
        type: Boolean,
        default: false
    },
    icon: {
        type: Object
    },
    iconClass: {
        type: String
    }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    appear: "",
    show: __props.show,
    as: "template"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close'))),
        class: "relative z-10"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TransitionChild), {
            as: "template",
            enter: "duration-300 ease-out",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "duration-200 ease-in",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "duration-300 ease-out",
                "enter-from": "opacity-0 scale-95",
                "enter-to": "opacity-100 scale-100",
                leave: "duration-200 ease-in",
                "leave-from": "opacity-100 scale-100",
                "leave-to": "opacity-0 scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), {
                    class: _normalizeClass([__props.width, "transform overflow-hidden rounded bg-white py-14 px-10 text-center align-middle transition-all"])
                  }, {
                    default: _withCtx(() => [
                      (__props.checkIcon)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createVNode(_unref(CheckCircleIcon), { class: "w-9 h-9 text-primary-500 mx-auto" })
                          ]))
                        : _createCommentVNode("", true),
                      (__props.withIcon)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(__props.icon), {
                              class: _normalizeClass(["size-9 mx-auto", __props.iconClass])
                            }, null, 8, ["class"]))
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_unref(DialogTitle), {
                        as: "p",
                        class: "text-xl font-bold text-primary-500"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.title), 1)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_6, [
                        (__props.content)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(__props.content), 1))
                          : _createCommentVNode("", true),
                        _renderSlot(_ctx.$slots, "content")
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(ButtonComponent, {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('confirm'))),
                          text: __props.actionText,
                          disabled: __props.loader
                        }, null, 8, ["text", "disabled"]),
                        (__props.cancelText)
                          ? (_openBlock(), _createElementBlock("p", {
                              key: 0,
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
                              class: "mt-5 text-primary-500 cursor-pointer"
                            }, _toDisplayString(__props.cancelText), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 3
                  }, 8, ["class"])
                ]),
                _: 3
              })
            ])
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["show"]))
}
}

})